module.exports = __webpack_public_path__ + "img/ONA_Nivel_2.53bff3c7.png";